import { BlockProps, useStyletron } from "@mezo-org/mezo-clay"

import { SIDEBAR_NAVIGATION_WIDTH } from "#/shared/constants"
import { useHomeRoute, useMarketRoute, useMobileScreen } from "#/shared/hooks"

import FullHeightContainer from "./FullHeightContainer"

export default function GridContainer({ children, ...props }: BlockProps) {
  const isMobileScreen = useMobileScreen()
  const isHomeRoute = useHomeRoute()
  const isMarketRoute = useMarketRoute()

  const [, theme] = useStyletron()

  return (
    <FullHeightContainer
      backgroundColor={
        isHomeRoute || isMarketRoute
          ? theme.colors.white
          : theme.colors.backgroundSecondary
      }
      width={
        isMobileScreen ? "100%" : `calc(100% - ${SIDEBAR_NAVIGATION_WIDTH})`
      }
      {...props}
    >
      {children}
    </FullHeightContainer>
  )
}
